export default "__VITE_ASSET__CmAGxQ9m__"